import React from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useTranslation } from "react-i18next";
import { useGetCompanySpecificServicesPaymentIntervals } from "@/services/Company";

type keyOptions = "id" | "code" | "description" | "triggerRegisterTask" | "registrationTask";

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions;
  editable?: boolean;
  companyId: number | undefined;
}

const SelectPaymentFrequency: React.FC<SelectPropsExtended> = ({ valueKey, labelKey, companyId, ...restProps }) => {
  const { data: paymentIntervals, isLoading } = useGetCompanySpecificServicesPaymentIntervals({
    enabled: !!companyId,
  });
  const { t } = useTranslation();

  const options = transformDataToSelectOption(
    paymentIntervals || [],
    valueKey || "id",
    labelKey || "code",
    t,
    "enumerables:paymentIntervals"
  );

  return <Select data={options} loading={isLoading} {...restProps} />;
};
export default SelectPaymentFrequency;
